import React, {useEffect} from "react";
import {Card} from "antd";
import SearchForm from "./SearchForm";
import RoList from "./RoList";
import {useModelDispatchers} from "../../../models";

export default function () {
    const {
        getInvoiceTypeDict,
        getCustomerDict,
        getSaleReturnPayStatusDict,
        getOrgDict,
        getWarehouseDict,
        getAreaDict,
        getShelveDict,
        getPositionDict,
        getSaleReturnStatusDict,
        getPayTypeDict,
    } = useModelDispatchers("cmDict");

    useEffect(() => {
        getInvoiceTypeDict();
        getCustomerDict();
        getSaleReturnPayStatusDict();
        getOrgDict();
        getWarehouseDict();
        getAreaDict();
        getShelveDict();
        getPositionDict();
        getSaleReturnStatusDict();
        getPayTypeDict();
    }, []);
    return (
        <>
            <Card
                bordered={true}
                className="margin-top-8"
                style={{display: "flex"}}
            >
                <div
                    style={{
                        margin: "8px 20px"
                    }}
                >
                    <SearchForm/>
                </div>
            </Card>
            <Card
                bordered={true}
                className="margin-top-8"
            >
                <RoList/>
            </Card>
        </>
    )
}